export function removeObjectEmptyFields(object = {}) {
  if (!object) {
    return {};
  }

  return Object.fromEntries(Object.entries(object)?.filter(([_, v]) => v != null));
}
